export default __webpack_public_path__ + "static/media/timeline_new.1569d27e.png";